export const categories = [
  { slug: 'rexue', name: '热血', icon: 'ri-fire-line', description: '激情燃烧的战斗与冒险故事' },
  { slug: 'gaoxiao', name: '搞笑', icon: 'ri-emotion-laugh-line', description: '轻松幽默的欢乐日常' },
  { slug: 'lianai', name: '恋爱', icon: 'ri-heart-line', description: '甜蜜动人的爱情故事' },
  { slug: 'xuanyi', name: '悬疑', icon: 'ri-search-eye-line', description: '扣人心弦的推理与谜题' },
  { slug: 'qihuan', name: '奇幻', icon: 'ri-magic-line', description: '天马行空的异世界冒险' },
  { slug: 'richang', name: '日常', icon: 'ri-sun-line', description: '温馨治愈的生活点滴' },
  { slug: 'kehuan', name: '科幻', icon: 'ri-rocket-line', description: '未来世界的科技幻想' },
  { slug: 'kongbu', name: '恐怖', icon: 'ri-ghost-line', description: '惊悚刺激的恐怖故事' },
];

export type MangaCategory = typeof categories[number];